import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.929 1.277h-5.11a2.676 2.676 0 0 0-2.67 2.67v8.18a2.676 2.676 0 0 0 2.67 2.67h6.36a2.676 2.676 0 0 0 2.67-2.67v-6.24h.01V5.2Zm2.42 10.85a1.171 1.171 0 0 1-1.17 1.17h-6.36a1.178 1.178 0 0 1-1.17-1.17v-8.18a1.178 1.178 0 0 1 1.17-1.17h4.43v3.11h3.1Zm-3.04-2.81v1.5h-3.92v-1.5Zm1.31-2.4v1.5h-5.23v-1.5Z';
const draw24px =
  'M15,1.89H7.06A3.76,3.76,0,0,0,3.31,5.63V18.37a3.76,3.76,0,0,0,3.75,3.75H17a3.76,3.76,0,0,0,3.75-3.75V7.64Zm4.26,16.48A2.25,2.25,0,0,1,17,20.62H7.06a2.25,2.25,0,0,1-2.25-2.25V5.63A2.25,2.25,0,0,1,7.06,3.38H14V8.64h5.26ZM16,12.75H8v-1.5h8Zm-2,3.66H8v-1.5h6Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentTextIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'documentText'),
) as IconWithRender;

DocumentTextIcon.displayName = 'DocumentTextIcon';
DocumentTextIcon.propTypes = Icon.propTypes;
DocumentTextIcon.renderIcon = (props) => <DocumentTextIcon {...props} />;
export default DocumentTextIcon;
